import React from 'react';

class CommentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const text = this.state.value;
    this.props.onSubmit(null, text);
    this.setState({ value: '' });
  }

  render() {
    return (
      <form method="post" className="well padding-bottom-10" onSubmit={this.handleSubmit} >
        <textarea rows="2" value={this.state.value} className="form-control" placeholder="Add Comment" onChange={this.handleChange}></textarea>
        <div className="margin-top-10" style={{ height: "30px" }}>
          <button disabled={this.props.isExecutive} type="submit" className="btn btn-sm btn-primary pull-right">
            Add Comment
					</button>
        </div>
      </form>
    );
  }
}
export default CommentForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/CommentForm.js